/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dialog-container[_ngcontent-%COMP%]   .dialog-title[_ngcontent-%COMP%]{background:#ff6b6b}.dialog-container[_ngcontent-%COMP%]   .dialog-body[_ngcontent-%COMP%]   .icon-box[_ngcontent-%COMP%]{color:#ff6b6b}"];
export { styles as styles };
